import { DayPlan } from "../../types/DayPlan";
import DB_PATH from "../DB_PATH";
import firebase from "../firebase";

export default async ({ dayPlanId }: { dayPlanId: string }) => {
  try {
    console.log('Removing Day Plan', dayPlanId)
    const firestore = firebase.firestore();
    await firestore.collection(DB_PATH.PLAN_DAY).doc(dayPlanId).delete();
  } catch (error) {
    console.error("Error creating daily step:", error);
  }
};
